import { Component, Input, NgZone } from "@angular/core";
import { EChartsOption } from "echarts";
import { IChartData } from "src/app/models/api/dashboards.model";
import { createChartSetup as createChartOptions } from "./utils";
import { ISelectedFilters } from "src/app/models/filters/selectedFilters.interface";
import { FiltersQueryTransformer } from "src/app/services/filters/filtersQueryTransformer.ts/filtersQueryTransformer";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "app-pie-animation-chart",
    templateUrl: "./pie-animation-chart.component.html",
    styleUrls: ["./pie-animation-chart.component.scss"],
})
export class PieAnimationChartComponent {
    @Input() public title: string;
    @Input() public tooltip: string;
    @Input() public selectedFilters: ISelectedFilters;
    @Input() public set seriesDetails(series: IChartData[]) {
        this.options = createChartOptions(series);
    }

    public options: EChartsOption;

    constructor(
        private _ngZone: NgZone,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
    ) {}

    /* eslint-disable @typescript-eslint/no-explicit-any */
    public onChartClick(event: any): void {
        this._ngZone.run(() => {
            if (event.componentType === "series" && event.seriesType === "pie" && event.data.pageLinkName) {
                let fullQuery = FiltersQueryTransformer.transformToQuery(this.selectedFilters);
                if (event.data.selectedFilters) {
                    fullQuery += ` ${FiltersQueryTransformer.transformToQuery(event.data.selectedFilters)}`;
                }
                this._router.navigate([event.data.pageLinkName], {
                    relativeTo: this._activatedRoute.parent,
                    queryParams: { q: fullQuery },
                    queryParamsHandling: "merge",
                });
            }
        });
    }
}
